import { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import { useNavigate, useNavigation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { errorToast, successToast } from "../../helpers";
import Pagination from "../../components/Pagination";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import { DayPicker } from "react-day-picker";
import moment from "moment";
import { Clear } from "@mui/icons-material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import WarnModal from "../../components/WarnModal";
import {
  useAllNotificationsMutation,
  useDeleteNotificationMutation,
} from "../../services/notification";
import useTranslation from "../../hooks/Translation";

const ManageNotifications = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [row1, setRow1] = useState<any>([]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedId, setSelectedId] = useState<number>(0);

  const [deleteNotification] = useDeleteNotificationMutation();
  const [allNotifications] = useAllNotificationsMutation();
  const [totalRecords, setTotalRecords] = useState(10);

  const formatDate = (isoString: string | number | Date) => {
    const date = new Date(isoString);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getAllNotifications = async (page: any) => {
    let body = {
      length: limit,
      start: page,
      search: debouncedSearchTerm,
    };

    try {
      const response = await allNotifications(body).unwrap();
      if (response?.status === 200) {
        console.log(response.data.response_object);
        setTotalPages(Math.ceil(response?.data?.total_records / limit));
        // console.log()
        setTotalRecords(response?.data?.total_records);
        setRow1(response.data.response_object);
        // setCategoryData(response?.data?.response_object);
      } else {
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getAllNotifications(page);
  }, [limit, debouncedSearchTerm]);

  const handleDeleteNotification = async (id: any) => {
    try {
      const response = await deleteNotification(id).unwrap();
      if (response?.status === 200) {
        getAllNotifications(page);
        successToast("Notification deleted successfully");
        // navigate('/manage-notifications')
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  console.log("getToken");
  return (
    <div>
      <div className="main_layout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.notificationManagement}</h1>
        </div>
        {/* <Loader isLoasd={isLoading} /> */}
        <Card className="cards">
          <Box className="cards_header" style={{ marginBottom: 20 }}>
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-notifications/add")}
              >
                <AddIcon /> {t.main.addNotification}
              </Button>
            </Box>
          </Box>

          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>{t.main.sentTo}</TableCell>
                  <TableCell>{t.main.date}</TableCell>

                  <TableCell>{t.main.title}</TableCell>
                  <TableCell>{t.main.messages}</TableCell>

                  <TableCell align="center">{t.main.delete}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row1.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      {t.error.noData}
                    </TableCell>
                  </TableRow>
                ) : (
                  row1?.map((row: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>{row?.notification_for}</TableCell>
                      <TableCell> {formatDate(row?.created_at)}</TableCell>
                      <TableCell>{row?.title}</TableCell>

                      <TableCell>{row?.message}</TableCell>

                      <TableCell align="center">
                        <Box className="table_actions">
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(row?.id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {row1?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={row1}
          page={page}
          onPageChange={setPage}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          limit={limit}
          setLimit={setLimit}
          totalRecords={totalRecords}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteNotification(selectedId)}
        name={t.main.notification}
      />
    </div>
  );
};

export default ManageNotifications;
